export const SKIP_INITIALIZE = 'skiping analytics initialization'
export const MESSAGE_SUCCESS = 'Analytics initialized'

export const PLAYER_CONTEXT = {
  LMS: 'LMS',
  FAMILY: 'FAMILY',
  MARKETING: 'MARKETING',
  CONTENTFUL: 'CONTENTFUL',
}
